import React from 'react'
import { Box, Checkbox as Base } from 'rebass'
import startCase from 'lodash.startcase'

import Text from './Text'
import Label from './Label'

const Checkbox = ({hideLabel, label, required, field, mb, form: {touched, errors, isSubmitting}, ...others}) =>
  <Box mb={mb || 3}>
    <Label mb={1}>{label || startCase(field.name)}{required && '*'}
      <Base ml={2} readOnly={isSubmitting} {...field} {...others} />
    </Label>
    {touched[field.name] && errors[field.name] && <Text error f={1} ml={2}>{errors[field.name]}</Text>}
  </Box>

export default Checkbox



// WEBPACK FOOTER //
// ./src/components/Checkbox.js